<template>
  <section>
    <nav-bar :title="'Learn skills'"></nav-bar>
    <div
      class="atm-desktop-max-width mobile d-flex flex-wrap gap-4 justify-content-center align-items-stretch mx-auto"
    >
      <template v-if="loading">
        <skeleton-learn-skills></skeleton-learn-skills>
      </template>
      <template v-else>
        <learn-skills-item
          v-for="(skill, index) in moduleSkills"
          :key="index"
          :name="skill.name"
          :topics="skill.topics"
          :topicsViewed="skill.topics_viewed"
          :skillId="skill.id"
          :icon="skill.icon"
          :countLessons="skill.pages.length"
        />
      </template>
    </div>
  </section>
</template>

<script>
import { getModuleSkills } from '../services';
import { NavBar } from '@/common/components';
import LearnSkillsItem from '../components/LearnSkillsItem.vue';
import SkeletonLearnSkills from '../components/skeletons/SkeletonLearnSkills.vue';
import notificationToastMixin from '@/Mixins/notificationToast.mixin';

export default {
  components: { NavBar, LearnSkillsItem, SkeletonLearnSkills },
  data() {
    return {
      moduleSkills: [],
      loading: false,
      notificationSetup: {},
    };
  },
  mixins: [notificationToastMixin],
  async mounted() {
    if(this.$route.params.markComplete){
      this.notificationToast({
        message: 'Lesson completed successfully',
        variant: 'primary',
        title: 'Success',
      });
    }
    try {
      this.loading = true;
      this.moduleSkills = await getModuleSkills();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

